import BannerOneColumn from './BannerOneColumn'
import { reactToCwp } from '../../../../../../common/react-utils'

export default reactToCwp(BannerOneColumn)
